/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import {
  urlsGeneral,
  listMultipleAssetsUrls,
  assetsBatchesUrls,
  assetUrls,
  samsUrls,
  samsBuildBatchesUrls,
  manageSamListingsUrls,
  pendingSamsUrls
} from '@/configs/urls'
import { REGISTER_ASSETS } from '@/configs/strings/register-multiple-assets'
import { LIST_MULTIPLE_ASSETS, YOUR_SAMS } from '../strings/list-multiple-assets'
import { UPLOAD_REGISTER_SINGLE_ASSET } from '@/configs/strings/upload-register-single-asset'
import { NavLink } from 'react-router-dom'
import { LIST_SAMS_FOR_LICENSING_TITLE } from '../strings/manage-sam-listings'
import { YOUR_PENDING_SAMS } from '../strings/pending-sams'
import { BUILD_SAM_BATCHES_TITLE } from '../strings/sams-build-batches.strings'

export const menuGeneral = [
  {
    as: NavLink,
    to: `/${urlsGeneral.works}`,
    label: 'Your Assets',
    iconType: 'collection'
  },
  {
    as: NavLink,
    to: `/${assetsBatchesUrls.base}`,
    label: REGISTER_ASSETS,
    iconType: 'collection'
  },
  {
    as: NavLink,
    to: `/${listMultipleAssetsUrls.base}`,
    label: LIST_MULTIPLE_ASSETS,
    iconType: 'collection'
  },
  {
    as: NavLink,
    to: `/${samsUrls.base}`,
    label: YOUR_SAMS,
    iconType: 'collection'
  },
  {
    as: NavLink,
    to: `/${pendingSamsUrls.base}`,
    label: YOUR_PENDING_SAMS,
    iconType: 'collection'
  },
  {
    as: NavLink,
    label: BUILD_SAM_BATCHES_TITLE,
    to: `/${samsBuildBatchesUrls.base}`,
    iconType: 'collection'
  },
  {
    as: NavLink,
    label: LIST_SAMS_FOR_LICENSING_TITLE,
    to: `/${manageSamListingsUrls.base}`,
    iconType: 'collection'
  },
  {
    as: NavLink,
    to: `/${assetUrls.base}/${assetUrls.new}`,
    label: UPLOAD_REGISTER_SINGLE_ASSET,
    iconType: 'collection'
  }
]
